import { render } from "./MenuOption.vue?vue&type=template&id=4f745433"
import script from "./MenuOption.vue?vue&type=script&lang=js"
export * from "./MenuOption.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__